

















import Vue from 'vue'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import ImageUpload from "@/components/common/ImageUpload.vue"
import PrimaryButtons from '@/components/common/PrimaryButtons.vue'
import SingleAssetUpload from '@/components/base/SingleAssetUpload'
import { ImageClipper } from '@/utils/imageClipper'
import { AssetUsage } from '@/utils/assetUsage'
import { AssetsModule } from '@/store/modules/asset'
import { AppModule } from '@/store/modules/app'
import { TreasureBookModule } from '@/store/modules/treasureBook'
import { AssetFile, SingleAssetUsage } from '@/store/modules/asset'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'

@Component({
    name: 'design-title-image',
    components: { PrimaryButtons, ImageUpload }
})
export default class DesignTitleUpload extends Mixins(SingleAssetUpload) {

    doConfirm(asset?: AssetFile, imageClipper?: ImageClipper, usage?: SingleAssetUsage): boolean {
        if (AssetsModule.selected && asset && asset.assetId && usage && imageClipper) {
            TreasureBookModule.SetInnerImageBoundingBox(imageClipper.boundingBox)
            TreasureBookModule.SetInnerImageRotation(usage.rotation)
            TreasureBookModule.SetInnerImageAssetId(asset.assetId)
            return true
        } else {
            if (!asset || !AssetsModule.selected) {
                AssetUsage.deleteAllUsage()
                TreasureBookModule.SetInnerImageAssetId(-1)
                return true
            } else {
                return false
            }
        }
    }

    get confirmable(): boolean {
        return !ToolbarModule.error
    }

    get parentGender() {
        return TreasureBookModule.parentGender
    }

    useDefaultImage() {
        this.asset = undefined
        let selectedAsset = AssetsModule.selected
        if (selectedAsset) {
            AssetUsage.captureUsage(selectedAsset)
            AssetsModule.Select()
        }
        AssetsModule.Select(undefined)
        ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
    }
}
